import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
import NavigationAppShell from '../../common/navigation-app-shell'
import * as appActions from '../../store/app'
import Styles from '../../common/styles'

const mapStateToProps = state => ({
  app: state.app
})

const mapDispatchToProps = dispatch => ({
  appActions: bindActionCreators(appActions, dispatch)
})

class AppPage extends Component {
  seedDb = e => {
    e.preventDefault()
    this.props.appActions.seedDb()
  }

  render () {
    const { classes, app } = this.props
    return (
      <NavigationAppShell
        content={
          <Paper>
            {app.loading && <LinearProgress />}
            <div className={classes.content}>
              <form onSubmit={e => this.seedDb(e)}>
                <Button variant='raised' color='primary' style={{ color: '#fff' }} type='submit'>{'Seed'}</Button>
              </form>
            </div>
          </Paper>
        }
        pageName={'App'}
      />
    )
  }
}

AppPage = connect(mapStateToProps, mapDispatchToProps)(AppPage)
export default withStyles(Styles)(AppPage)



// WEBPACK FOOTER //
// ./src/pages/app/index.js